<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { AlertType } from '../../../../Constants/AlertType.ts'
import Alert from '../UI/Alert.vue'

const { t } = useI18n()
</script>

<template>
  <Alert :type="AlertType.WARNING">
    {{ t('service.fields.levels.errors.missingTerms') }}
  </Alert>
</template>
